<template>
    <div class="vxe-table-wrap">
        <template v-if="isShowToolBar">
            <vxe-toolbar ref="toolbarRef" custom></vxe-toolbar>
        </template>
        <vxe-table
            ref="pVxeTable"
            :key="tableKey"
            v-bind="$attrs"
            v-on="$listeners"
            :align="align"
            :auto-resize="autoResize"
            :border="border"
            :cell-class-name="cellClassName"
            :cell-style="cellStyle"
            :checkbox-config="checkboxOpts"
            :row-id="rowId"
            :column-config="columnOpts"
            :custom-config="customConfig"
            :data="tData"
            :edit-config="editOpts"
            :expand-config="expandConfig"
            :footer-align="footerAlign"
            :footer-cell-class-name="footerCellClassName"
            :footer-data="footerData"
            :footer-method="footerMethod"
            :footer-row-class-name="footerRowClassName"
            :footer-span-method="footerSpanMethod"
            :header-align="headerAlign"
            :header-cell-class-name="headerCellClassName"
            :header-row-class-name="headerRowClassName"
            :height="height"
            :keep-source="keepSource"
            :loading="loading"
            :loading-config="loadingOpts"
            :max-height="maxHeight"
            :menu-config="ctxMenuOpts"
            :min-height="minHeight"
            :radio-config="radioOpts"
            :resize-config="resizeOpts"
            :row-class-name="rowClassName"
            :row-config="rowOpts"
            :show-footer="showFooter"
            :show-footer-overflow="showFooterOverflow"
            :show-header-overflow="showHeaderOverflow"
            :show-overflow="showOverflow"
            :span-method="spanMethod"
            :stripe="stripe"
            :tooltip-config="tooltipOpts"
            :tree-config="treeOpts"
            class="thin-scrollbar"
            @scroll="handleScroll($event)"
            @header-cell-click="$emit('headerCellClick')"
            @header-cell-dblclick="$emit('headerCellDblclick')"
            @header-cell-menu="$emit('headerCellMenu')"
            @cell-click="$emit('cellClick')"
            @cell-dblclick="$emit('cellDBLClick')"
            @cell-mouseenter="$emit('cellMouseenter')"
            @cell-mouseleave="$emit('cellMouseleave')"
            @cell-menu="$emit('cellMenu')"
            @radio-change="$emit('radioChange')"
            @checkbox-change="checkboxChange"
            @checkbox-all="checkboxAll">
            <slot></slot>
            <template v-slot:empty>
                <slot name="empty"></slot>
            </template>
        </vxe-table>
        <template v-if="showPagination && pagination.total">
            <el-pagination
                :current-page.sync="pagination.pageNum"
                :layout="pagination.layout"
                :page-size="pagination.pageSize"
                :page-sizes="pagination.pageSizes"
                :total="pagination.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            >
            </el-pagination>
        </template>
    </div>
</template>
<script>
import GlobalConfig from "./config";
import { getTableHeight } from "@/utils";
import XEUtils from "xe-utils";

export default {
    name: "CommonVxeTable",
    props: {
        rowId:{
            type: String,
            default: 'id',
        },
        isShowToolBar: {
            type: Boolean,
            default: false,
        },
        tableData: {
            type: Array,
            default: () => [],
        },
        reduceHeight: {
            type: Number,
            default: 140,
        }, // 减去的高度
        tableHeight: {
            type: [Number, String],
        },
        minHeight: {
            type: [Number, String],
            default: () => GlobalConfig.table.minHeight,
        },
        maxHeight: {
            type: [Number, String],
            default: () => GlobalConfig.table.maxHeight,
        },
        // 最终高度需要再减去的高度，常用来减去已知的自定义元素高度，此数值需要是1920*1080分辨率下的像素值(只有不传入其它任何高度限制时生效)
        dynamicHeight: {
            type: [Number, String],
            default: 0,
        },
        // 保持原始值的状态，被某些功能所依赖，比如编辑状态、还原数据等（开启后影响性能，具体取决于数据量）
        keepSource: {
            type: Boolean,
            default: () => GlobalConfig.table.keepSource,
        },
        // 是否自动监听父容器变化去更新响应式表格宽高
        autoResize: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
        // 响应式布局配置项
        resizeConfig: {
            type: Object,
        },
        // 是否带有斑马纹
        stripe: { type: Boolean, default: () => GlobalConfig.table.stripe },
        border: {
            type: [Boolean, String],
            default: () => GlobalConfig.table.border,
        },
        loading: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
        // 修改加载中图标
        loadingConfig: {
            type: Object,
        },
        // 所有的列对其方式
        align: { type: String, default: () => GlobalConfig.table.align },
        // 所有的表头列的对齐方式
        headerAlign: {
            type: String,
            default: () => GlobalConfig.table.headerAlign,
        },
        // 所有的表尾列的对齐方式
        footerAlign: {
            type: String,
            default: () => GlobalConfig.table.footerAlign,
        },
        // 给行附加 className
        rowClassName: {
            type: [String, Function],
            default: () => {
                return "";
            },
        },
        // 给单元格附加 className
        cellClassName: [String, Function],
        // 给表头的行附加 className
        headerRowClassName: [String, Function],
        // 给表头的单元格附加 className
        headerCellClassName: [String, Function],
        rowConfig: {
            type: Object,
        },
        // 列默认配置项
        columnConfig: {
            type: Object,
            default: () => GlobalConfig.table.columnConfig,
        },
        // 快捷菜单配置项（右键）
        menuConfig: {
            type: Object,
        },
        // 展开行配置项
        expandConfig: {
            type: Object,
        },
        // 编辑配置项
        editConfig: {
            type: Object,
        },
        // 合并指定单元格
        // mergeCells: {
        //     type: Array,
        // },
        // tooltip 配置项
        tooltipConfig: {
            type: Object,
        },
        // 树形结构配置项
        treeConfig: [Boolean, Object],
        radioConfig: {
            type: Object,
        },
        checkboxConfig: {
            type: Object,
        },
        // 设置所有内容过长时显示为省略号
        showOverflow: {
            type: [Boolean, String],
            default: () => GlobalConfig.table.showOverflow,
        },
        // 设置表头所有内容过长时显示为省略号
        showHeaderOverflow: {
            type: [Boolean, String],
            default: () => GlobalConfig.table.showHeaderOverflow,
        },
        // 设置表尾所有内容过长时显示为省略号
        showFooterOverflow: {
            type: [Boolean, String],
            default: () => GlobalConfig.table.showFooterOverflow,
        },
        // 是否显示表尾合计
        showFooter: {
            type: Boolean,
        },
        // 表尾数据
        footerData: {
            type: Array,
        },
        // 自定义合并行或列的方法
        spanMethod: Function,
        // 表尾合并行或列
        footerSpanMethod: Function,
        // 给表尾的行附加 className
        footerRowClassName: [String, Function],
        // 给表尾的单元格附加 className
        footerCellClassName: [String, Function],
        // 给单元格附加样式
        cellStyle: [Object, Function],
        // 需要计算合计的列的key, 二维数组, key可以是无序的 [['第一行key1', '第一行key2'],['第二行key1','第二行key2']], 如果只传一个数组，后续计算则复用
        summaryColKeyList: Array,
        /**
         * 合计描述及计算规则, 对应footerMethod方法的返回值(多行合计数组)，即：
         * [{columnIndex: '第一行合计行描述列下标', text: '描述', ruleName: '计算规则(求和)'},{columnIndex: '第二行合计行描述列下标',text: '描述', ruleName: '计算规则(平均值)'}]
         * 计算规则参数(ruleName): add 求和, avg 平均值 , 默认值:add。结果保留2位小数
         */
        sumConfig: {
            type: Array,
            required: false,
            default: () => {
                return [{ columnIndex: 1, text: "合计(元)", ruleName: "add" }];
            },
        },
        /**
         * 如果不想自动求和，比如直接使用后端请求回来的数据，则需要手动设置summaryData。此时将不启用sumConfig中的(ruleName)计算规则进行计算
         * 对象数组(对应summaryColKeyList中的key) [{第一行key1:'第一行key1的值', 第一行key2:'第一行key2的值'},...]
         */
        summaryData: Array,
        showPagination: {
            type: Boolean,
            default: () => {
                return true;
            },
        },
        pagination: {
            type: Object,
            default: () => {
                return {
                    pageNum: 1,
                    pageSize: 15,
                    pageSizes: [15, 30, 50, 100],
                    layout: "total, prev, pager, next, sizes, jumper",
                    total: 0,
                };
            },
        },
        customConfig: {
            type: Object,
            default: () => {
                return {
                    // placement: "bottomRight"
                    storage: true,
                    allowFixed: false,
                    confirmButtonText: "确定",
                    resetButtonText: "重置",
                    visibleMethod: (col) => {
                        return true;
                    },
                    checkMethod: (col) => {
                        return true;
                    },
                    allowSort: true,
                };
            },
        },
    },
    data() {
        return {
            height: "",
            tableKey: Math.random(),
        };
    },
    watch: {
        reduceHeight(newVal, oldVal) {
            this.$nextTick(() => {
                this.autoHeight();
            });
        },
    },
    computed: {
        tData() {
            if (this.tableData.length > 0) {
                this.autoHeight();
            }
            return this.tableData;
        },
        columnOpts() {
            return Object.assign({}, GlobalConfig.table.columnConfig, this.columnConfig);
        },
        rowOpts() {
            return Object.assign({}, GlobalConfig.table.rowConfig, this.rowConfig);
        },
        resizeOpts() {
            return Object.assign({}, GlobalConfig.table.resizeConfig, this.resizeConfig);
        },
        radioOpts() {
            return Object.assign({}, GlobalConfig.table.radioConfig, this.radioConfig);
        },
        checkboxOpts() {
            return Object.assign({}, GlobalConfig.table.checkboxConfig, this.checkboxConfig);
        },
        tooltipOpts() {
            return Object.assign({}, GlobalConfig.table.tooltipConfig, this.tooltipConfig);
        },
        // 可编辑配置项
        editOpts() {
            return Object.assign({}, GlobalConfig.table.editConfig, this.editConfig);
        },
        treeOpts() {
            return Object.assign({}, GlobalConfig.table.treeConfig, this.treeConfig);
        },
        // 右键菜单配置项
        ctxMenuOpts() {
            return Object.assign({}, GlobalConfig.table.menuConfig, this.menuConfig);
        },
        loadingOpts() {
            return Object.assign({}, GlobalConfig.table.loadingConfig, this.loadingConfig);
        },
    },
    mounted() {
        const $table = this.$refs.pVxeTable;
        const $toolbar = this.$refs.toolbarRef;
        if ($table && $toolbar) {
            $table.connect($toolbar);
        }
        let _self = this;
        _self.autoHeight();
        // 监听页面缩放, 重新计算表格高度
        window.onresize = XEUtils.debounce(() => {
            return (() => {
                _self.autoHeight();
            })();
        }, 200);
    },
    methods: {
        // 自定义表头配置
        handleOpenCustomShow() {
            this.$refs.pVxeTable.openCustom();
        },
        // 表尾合计,
        footerMethod({ columns, data }) {
            let _self = this;
            let sumRows = [];
            return sumRows;
        },

        // 根据sumConfig中配置的计算规则进行计算
        sumNum(list, field, rule) {
            let count = 0;
            if (rule == "add") {
                list.forEach((item) => {
                    count = accAdd(count, Number(item[field]));
                });
                return Math.round(count * 100) / 100;
            }
            if (rule == "avg") {
                // 求平均...
                list.forEach((item) => {
                    count += Number(item[field]);
                });
                return Math.round((count / list.length) * 100) / 100;
            }
        },
        // checkbox选中状态变换. 兼容el-table
        checkboxChange(params) {
            let selections = params.records || [];
            let selectionIds = selections.map((item) => {
                return item.id;
            });
            this.$emit("selection-change", selections, selectionIds, params);
        },
        // 计算table页面高度： 如果传入自定义高度，则使用自定义高度，否则动态计算高度，其优先关系详见prop中文档说明
        autoHeight() {
            this.$nextTick(() => {
                this.height = getTableHeight(this.reduceHeight);
            });
        },
        // checkbox全选状态变换. 兼容el-table
        checkboxAll(params) {
            let selections = params.records || [];
            this.$emit("select-all", selections, params);
            // 兼容el-table 触发逻辑，select-all会联动selection-change
            let selectionIds = selections.map((item) => {
                return item.id;
            });
            this.$emit("selection-change", selections, selectionIds, params);
        },
        // checkbox清空
        removeCheckboxRow() {
            const data = this.$refs.pVxeTable.getData();
            this.$refs.pVxeTable.setCheckboxRow(data, false);
            this.$forceUpdate();
        },
        // 监听滚动条滚动
        handleScroll() {
            // let scrollTimeout = null;
            // const content = document.querySelector('.vxe-table');
            // if(content) {
            //     content.classList.remove('hide-scrollbar')
            // }
            // clearTimeout(scrollTimeout);
            // // 延迟一段时间（例如1000毫秒）后隐藏滚动条
            // scrollTimeout = setTimeout(function () {
            //     content.classList.add('hide-scrollbar');
            // }, 1000);
        },
        // 页数改变
        handleSizeChange(val) {
            this.$emit("handleSizeChange", { pageNum: 1, pageSize: val });
        },
        // 页码改变
        handleCurrentChange(val) {
            this.$emit("handleCurrentChange", val);
        },
    },
};
</script>
<style lang="scss" scoped>
.vxe-table-wrap {
    width: 100%;
    position: relative;

    .vxe-toolbar {
        position: absolute;
        right: 0;
    }
}

.vxe-table {
    margin-top: 16px;
    border-radius: 6px 6px 0 0;
    overflow: hidden;
}
</style>
<style lang="scss">
.el-pagination {
    padding: 16px 0 0;
}

.vxe-toolbar {
    position: absolute;
    right: 0;
    z-index: 100;
    background-color: rgb(237, 240, 244);
    border: none;
    padding: 0;
    display: none;

    .vxe-tools--operate {
        .vxe-button.type--button.is--circle {
            background-color: rgb(237, 240, 244) !important;
            border: none;

            i {
                font-size: 0;
            }
        }
    }
}

.vxe-table-custom-wrapper {
    top: 48px !important;

    .vxe-table-custom--header {
        display: none !important;
    }

    .vxe-table-custom--body {
        li:nth-last-child(1) {
            display: none;
        }
    }

    .vxe-table-custom--footer {
        height: 32px;
        justify-content: flex-end;
        align-items: center;
        gap: 12px;

        button {
            flex-grow: 0;
            width: 44px;
            height: 24px;
            text-align: center;
            line-height: 24px;
            border-radius: 4px;
        }

        button:nth-child(1) {
            border: 1px solid rgba(217, 217, 217, 1);

            &:hover {
                border-color: rgb(75, 162, 255);
                color: rgb(75, 162, 255) !important;
            }

            &:active {
                border-color: rgb(34, 121, 214);
                color: rgb(34, 121, 214) !important;
            }
        }

        button:nth-child(2) {
            display: none;
        }

        button:last-child {
            background-color: rgba(41, 144, 255, 1);
            color: #fff;

            &:hover {
                background-color: rgb(75, 162, 255);
                border-color: rgb(75, 162, 255);
                color: #fff !important;
            }

            &:active {
                background-color: rgb(34, 121, 214);
                border-color: rgb(34, 121, 214);
                color: #fff !important;
            }
        }
    }
}
</style>
